import React, { useMemo, useState } from 'react';

import { cancellationPolicyContext } from './context';
import { CancellationPolicyDrawer } from 'src/components/CancellationPolicyDrawer';

export function CancellationPolicyProvider({ children }: React.PropsWithChildren) {
    const [isOpen, setIsOpen] = useState(false);
    const value = useMemo(
        () => ({
            setOpen: setIsOpen,
            isOpen,
        }),
        [isOpen]
    );
    return (
        <cancellationPolicyContext.Provider value={value}>
            {children}
            <CancellationPolicyDrawer isOpen={isOpen} setOpen={setIsOpen} />
        </cancellationPolicyContext.Provider>
    );
}
